import { themes } from 'src/theme/theme';
import { StyleSheet } from 'react-native';
export const styles = StyleSheet.create({
  container: {},
  categoryTitle: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    height: 48,
  },
  subcategoryContainer: {
    marginLeft: 20,
  },
  checkboxContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    height: 48,
  },
  expandIconContainer: {
    borderColor: themes.light.gray_blue[5],
    backgroundColor: themes.light.white[1],
    borderWidth: 1,
    borderRadius: 2,
    justifyContent: 'center',
    alignItems: 'center',
    width: 20,
    height: 20,
  },
  expandIcon: {
    width: 20,
    height: 20,
  },
  searchContainer: {
    paddingVertical: 12,
    backgroundColor: themes.light.white[1],
    borderBottomWidth: 1,
    borderBottomColor: themes.light.gray_blue[6],
  },
  searchInputContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    borderWidth: 1,
    borderColor: themes.light.gray_blue[6],
    borderRadius: 8,
    backgroundColor: themes.light.white[1],
  },
  input: {},
  searchInput: {
    flex: 1,
    paddingHorizontal: 12,
    paddingVertical: 10,
    fontSize: 16,
    color: themes.light.gray_blue[1],
  },
  clearButton: {
    paddingHorizontal: 12,
    paddingVertical: 10,
  },
  clearButtonText: {
    fontSize: 20,
    color: themes.light.gray_blue[3],
    fontWeight: 'bold',
  },
  noResultsContainer: {
    paddingVertical: 40,
    paddingHorizontal: 20,
    alignItems: 'center',
    justifyContent: 'center',
  },
});
